export const MOBILE_WIDTH = 600;
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN;
export const APP_EMAIL_DOMAIN = process.env.REACT_APP_EMAIL_DOMAIN;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_KEY;
export const ZOOM_CLIENT_ID = process.env.REACT_APP_ZOOM_CLIENT_ID;
export const APP_NAME = 'fundraisertalk';
export const FB_FUNCTIONS_URL = process.env.REACT_APP_FB_FUNCTIONS_URL;
